const mutations = {
    ADD_ALL_COLLECTIONS(state, payload) {
        const auxItems = [...state.collectionsAll, ...payload];
        const diffItems = auxItems.filter(
            (value, index, self) =>
                self.findIndex((item) => item.id === value.id) === index
        );
        state.collectionsAll = diffItems;
    },
    SET_ERROR_COLLECTIONS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
